export default __webpack_public_path__ + "1cf952ad4e0e59d99fdcc9c701d7d324.png";